import React, { Component } from 'react'
import SocialButton from '../SocialButton'
import Api from '../../api'
import googleIcon from '../../images/google.svg'
import constants from '../../constants'


export default class LoginWithGoogle extends Component {
  api = new Api()
  state = {
    loading: false,
    errors: {}
  }

  handleSocialLogin = (user) => {
    this.setState({loading: true})
    const googleToken = user.token.accessToken
    const googleId = user.profile.id
    const email = user.profile.email
    this.api.loginWithGoogle(googleToken, googleId, email, (errors) => this.setState({errors, loading: false}))
  }

  handleSocialLoginFailure = (err) => {
    console.warn(err)
    this.setState({errors: {base: "Unable to login with Google"}})
  }


  render() {
    const { errors, loading } = this.state

    return (
      <div style={{marginTop: 20}}>
        { errors.base && <div className="base-errors">{ errors.base }</div> }
        <SocialButton
          provider="google"
          appId={constants.googleAppId}
          onLoginSuccess={this.handleSocialLogin}
          onLoginFailure={this.handleSocialLoginFailure}
          disabled={loading}
          className="login__with__google"
          scope={["email"]}
          >
          <span><img alt="Login with Google" src={googleIcon} className="login__with__google__icon" /></span>
          <span className="login__with__google__text">Login with Google</span>
        </SocialButton>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LoginWidget/LoginWithGoogle.js